
export class ContactsUtils {
    static exportToPdf(tableId: string, name?: string) {
       let printContents, popupWin;
      printContents = document.getElementById(tableId).innerHTML;
      console.log(printContents)
      popupWin = window.open('', '_blank', 'top=0,left=0,height=auto,width=auto');
      popupWin.document.open();
      popupWin.document.write(`
    <html>
      <head>
        <h3>Print tab</h3>
        <img class="fit-picture"
        src="https://www.stg.ma/site2/images/logo.png"
        alt="Grapefruit slice atop a pile of other slices">
  
      </head>
  <body onload="window.print();window.close()"><table class="table table-bordered">${printContents}</table></body>
    </html>`
      );
      popupWin.document.close();
    }
  }
  